import { useEffect, useState } from 'react';
import type { FontFamily } from '@bynder-studio/structured-text';
import { catchResponseError } from 'packages/helpers/helpers';
import creativeEditorService, { type CreativeTemplateResponse } from 'packages/services/creativeEditorService';
import { toFontFamilies } from 'packages/services/fontsAdapter';

export type CreativeTemplate = Omit<CreativeTemplateResponse, 'galleryFonts'> & { galleryFonts: FontFamily[] };

export default function useCreativeTemplate(id?: number, lastPublished = true) {
    const [template, setTemplate] = useState<CreativeTemplate | null>(null);

    useEffect(() => {
        if (!id) {
            return;
        }

        const req = creativeEditorService.getCreativeTemplate(id, lastPublished);

        req.then((res) => {
            if (res.status >= 400) {
                throw new Error('Failed to fetch creative template');
            }

            setTemplate({ ...res.json, galleryFonts: toFontFamilies(res.json.galleryFonts ?? []) });
        }).catch(catchResponseError);

        return () => creativeEditorService.abortRequest(req);
    }, [id, lastPublished]);

    return template;
}
